(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["agi-best-sellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('agi-best-sellers')) return;

    function rootUrl() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    class AgiBestSellers extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-bs-track]');
        this.prev = this.querySelector('[data-bs-prev]');
        this.next = this.querySelector('[data-bs-next]');
        if (this.track) {
          this.onScroll = this.updateArrows.bind(this);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('scrollend', this.onScroll);
          window.addEventListener('resize', this.onScroll);
          window.addEventListener('load', this.onScroll);
          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(this.onScroll);
            this.resizeObserver.observe(this.track);
          }
          this.updateArrows();
          requestAnimationFrame(this.onScroll);
        }
        if (this.prev) this.prev.addEventListener('click', () => this.page(-1));
        if (this.next) this.next.addEventListener('click', () => this.page(1));
        this.addEventListener('click', this.onQty.bind(this));
        this.addEventListener('submit', this.onAdd.bind(this));
      }

      disconnectedCallback() {
        if (this.onScroll) {
          window.removeEventListener('resize', this.onScroll);
          window.removeEventListener('load', this.onScroll);
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      page(dir) {
        const slide = this.track.querySelector('.agi-bs__slide');
        if (!slide) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = slide.getBoundingClientRect().width + gap;
        const perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
        this.track.scrollBy({ left: dir * perView * step, behavior: 'smooth' });
      }

      // Show an arrow only when a product is (partly) hidden on that side.
      updateArrows() {
        if (!this.track) return;
        const slides = this.track.querySelectorAll('.agi-bs__slide');
        if (!slides.length) {
          if (this.prev) this.prev.disabled = true;
          if (this.next) this.next.disabled = true;
          return;
        }
        const box = this.track.getBoundingClientRect();
        const first = slides[0].getBoundingClientRect();
        const last = slides[slides.length - 1].getBoundingClientRect();
        if (this.prev) this.prev.disabled = first.left >= box.left - 2;
        if (this.next) this.next.disabled = last.right <= box.right + 2;
      }

      onQty(event) {
        const btn = event.target.closest('[data-bs-qty]');
        if (!btn) return;
        const input = btn.parentElement.querySelector('input');
        const step = parseInt(input.step, 10) || 1;
        const min = parseInt(input.min, 10) || 1;
        const max = input.max ? parseInt(input.max, 10) : Infinity;
        const value = (parseInt(input.value, 10) || min) + step * parseInt(btn.dataset.bsQty, 10);
        input.value = Math.min(max, Math.max(min, value));
      }

      onAdd(event) {
        const form = event.target.closest('[data-bs-add]');
        if (!form) return;
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        const label = button.querySelector('[data-bs-label]');
        const msg = form.querySelector('.agi-bs-add__msg');
        const original = label.textContent;
        const drawer = document.querySelector('cart-drawer');
        const notification = document.querySelector('cart-notification');
        const cart = drawer || notification;
        const body = new FormData(form);
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.append('sections', cart.getSectionsToRender().map((section) => section.id));
          body.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        button.setAttribute('aria-busy', 'true');
        if (msg) msg.hidden = true;
        const url = (window.routes && window.routes.cart_add_url) || rootUrl() + 'cart/add';
        fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              if (msg) { msg.textContent = data.description || data.message || 'Could not add to cart'; msg.hidden = false; }
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.renderContents(data);
              if (drawer) drawer.classList.remove('is-empty');
            } else {
              this.refreshBubble();
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'agi-best-sellers', productVariantId: body.get('id'), cartData: data });
            }
            label.textContent = button.dataset.added || original;
            setTimeout(() => { label.textContent = original; }, 2000);
          })
          .catch(() => { form.submit(); })
          .finally(() => { button.removeAttribute('aria-busy'); });
      }

      refreshBubble() {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        fetch(rootUrl() + '?sections=cart-icon-bubble')
          .then((r) => r.json())
          .then((sections) => {
            if (!sections || !sections['cart-icon-bubble']) return;
            const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            const fresh = doc.querySelector('.shopify-section') || doc.body;
            bubble.innerHTML = fresh.innerHTML;
          })
          .catch(() => {});
      }
    }

    customElements.define('agi-best-sellers', AgiBestSellers);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
